export default "__VITE_ASSET__DwcHENT1__"